import { ExpressPaymentBreakdown } from '../types';
import { round } from './math.utils';
import { getDiscountsValue } from './discounts.utils';
import { CartModel } from '../models/Cart.model';
import { SummaryModel } from '../models/Summary.model';
import { PriceModel } from '../models/Price.model';
import { LineItemDiscountModel } from '../models/LineItemDiscount.model';

export function getPaymentBreakdown(
  cart: CartModel,
  summary: SummaryModel,
  discountsToAlignWith: LineItemDiscountModel[],
): ExpressPaymentBreakdown {
  const pricesIncludeTax = cart.pricesIncludeTax;

  const shipping =
    summary.priceSummary?.delivery?.amount ?? /* istanbul ignore next */ '0';
  const tax = pricesIncludeTax
    ? '0'
    : summary.priceSummary?.tax?.amount ?? /* istanbul ignore next */ '0';
  const discount = getTotalDiscount({
    discountsToAlignWith,
    taxExemptAmount: summary.taxExemptPrice?.amount ?? '0',
    payNow: summary.priceSummary,
    giftCardAmount: summary.giftCardAmount,
    pricesIncludeTax,
  });
  return {
    shipping,
    tax,
    discount,
  };
}

function getTotalDiscount({
  discountsToAlignWith,
  taxExemptAmount,
  payNow,
  giftCardAmount,
  pricesIncludeTax,
}: {
  discountsToAlignWith: LineItemDiscountModel[];
  taxExemptAmount: string;
  payNow: {
    discount?: PriceModel;
    shipping?: PriceModel;
    tax?: PriceModel;
  };
  giftCardAmount?: PriceModel;
  pricesIncludeTax?: boolean;
}) {
  const payNowDiscount =
    payNow.discount?.amount ?? /* istanbul ignore next */ '0';
  const lineItemDiscounts = getDiscountsValue(discountsToAlignWith);
  const discountTotal = Number(payNowDiscount) + lineItemDiscounts;
  const giftCardTotal = giftCardAmount?.amount ?? '0';
  const taxExemptTotal = pricesIncludeTax ? taxExemptAmount : '0';
  return round(
    Number(discountTotal) + Number(giftCardTotal) + Number(taxExemptTotal),
  ).toString();
}
